<template>
    <div class="container remove-padding-margin">
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"
                  v-if="isClickedloader === true"></span>
        </div>
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row set-row d-flex">
                    <div class="remove-padding navbar-icon-left" @click="back">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="text-center remove-padding flex-1 font-weight-600">
                        Ubah Email
                    </div>
                    <div class="navbar-icon-right remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 mar-top-60">
                    <div class="font-16 line-height-25 letter-space-002 color-0000 mar-bottom-16">Masukkan alamat email baru menggantikan <b>{{email_owner}}</b> untuk login Smartlink Owner.</div>
                    <div>
                        <label class="require color-6f7 font-14" for="newemail">Alamat Email Baru</label>
	                    <InputRegular
		                    v-model="emailnew"
		                    :type="'email'"
		                    :id="'newemail'"
		                    :placeholder="'contoh@email.com'"
		                    :classes="'form-control inputs'"
		                    :validationType="'email'"
		                    :checkPattern="'email'"
		                    ref="inputregular_email"
	                    />
	                    <ErrorMessage class="error" label="Email" :validation="$v.emailnew"></ErrorMessage>
                    </div>
                </div>
<!--                <div class="button-lanjut" v-if="status_password ==='tidak_ada'">-->
<!--                    <button class="btn btn-login btn-long" disabled id="btnubahemail" @click="ubahemail">-->
<!--                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"-->
<!--                              v-if="isClicked === true"></span>-->
<!--                        <span id="textBtnubahemail">Ubah Email</span>-->
<!--                    </button>-->
<!--                </div>-->
<!--                <div class="button-lanjut" v-else>-->
<!--                    <button class="btn btn-login btn-long" disabled id="btnubahemail"data-toggle="modal" data-target="#modalsecureemail">-->
<!--                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"-->
<!--                              v-if="isClicked === true"></span>-->
<!--                        <span id="textBtnubahemail">Ubah Email</span>-->
<!--                    </button>-->
<!--                </div>-->
	            <div class="button-lanjut">
		            <button class="btn btn-login btn-long" id="btnubahemail" @click="ubahemail">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span>
			            <span id="textBtnubahemail">Ubah Email</span>
		            </button>
	            </div>
            </div>
        </main>

        <div class="modal fade" id="modalsecureemail" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Verifikasi Keamanaan</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div>Silakan masukkan kata sandi saat ini untuk memastikan keamanan akun Anda.</div>
                        <label for="inputPass1" class="line-height-25 font-14 color-6f7 text-login-wa require mar-top-16 mar-bot-2">Kata sandi saat ini</label>
                        <input type="password" class="form-control inputs" id="inputPass1" @keyup="cekValidatepass1" v-model="password1">
                        <span toggle="#password-field1" v-on:click="changeViewPass1"
                              class="fa fa-eye field-icon toggle-password"></span>
                        <div class="mar-top-8" @click="forgotpass"><span class="color-206CF font-14">Lupa kata sandi</span></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"  disabled id="btnsecure1"  @click="verifikasipass">Berikutnya</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
	import InputRegular from "../../component-items/InputRegular";
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {email, required} from "vuelidate/lib/validators";

    export default {
        name: "EditEmail",
	    components: { InputRegular, ErrorMessage },
        data(){
          return{
              isClicked:false,
              isClickedloader:true,
              owner:{},
              email_owner:'',
              emailnew:'',
              status_password:'',
              password1:'',
              requestHeaders: {
                  headers: {
                      'Authorization': 'Bearer ' + localStorage.getItem('token'),
                  }
              },
          }
        },
	    validations: {
		    emailnew: {
		    	required,
			    email
		    }
	    },
        mounted() {
            this.getdetailowner();
            this.getpasswordowner()
        },
	    watch: {
        	emailnew: function () { this.cekValidateemail(); },
	    },
        methods:{
            back(){
                this.$router.push('/loginowneremail')
            },

            forgotpass(){
                this.$router.push('/forgotpassword/1')
            },

            next(){
                this.$router.push(`/successchangeemail/${this.emailnew}`)
            },

            cekValidatepass1() {
                var passData = this.password1;
                var lenPass = passData.length;
                if (lenPass >= 6) {
                    $('#btnsecure1').prop('disabled', false);
                } else {
                    $('#btnsecure1').prop('disabled', true);
                }
            },

            changeViewPass1(event) {
                if ($('#inputPass1').attr("type") == "password") {
                    $('.toggle-password').removeClass('fa fa-eye');
                    $('.toggle-password').addClass('fa fa-eye fa-eye-slash');
                    $('#inputPass1').attr("type", "text");
                } else {
                    $('.toggle-password').removeClass('fa fa-eye fa-eye-slash');
                    $('.toggle-password').addClass('fa fa-eye');
                    $('#inputPass1').attr("type", "password");
                }
            },

            async getdetailowner() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    var telp = localStorage.getItem("telp");
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner',  this.requestHeaders);
                    this.owner = res.data.data
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        this.isClickedloader = false;
                        // $('#loadingPage').hide();
                        var dataowner = res.data.data
                        this.email_owner = dataowner.email
                    }else{
						this.$toast.error(res.data.msg)
                    }
                } catch (e) {
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
                	
	                this.$catch_error_response(e)
	
	                this.isClicked = false
	                $('#textBtnpersonal').show()
	                $('#btnpersonal').prop('disabled', false);
                }
            },

            cekValidateemail() {
            	return
                var emailData = this.emailnew;
                // var lenPass = emailData.length;
                if (this.$refs.inputregular_email.validatePattern('email')) {
                    $('#btnubahemail').prop('disabled', false);
                } else {
                    $('#btnubahemail').prop('disabled', true);
                }
            },

            async ubahemail(){
            	if (this.$v.emailnew.$invalid) {
		            this.$v.emailnew.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                var emailData = this.emailnew;
                this.isClicked = true;
                $('#textBtnubahemail').hide();
                $('#btnubahemail').prop('disabled', true);
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    const dataUser = new FormData;
                    // dataUser.append('email_baru', emailData);
                    // const res = await this.$axios.post(this.$baseurl + '/masterData/owner/ubah_email_owner', dataUser,this.requestHeaders)
	                dataUser.append("email", emailData)
	                const res = await this.$axios.post(this.$baseurl + "/auth/send_verifikasi_ubah_email_baru", dataUser, this.requestHeaders)
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false;
                        this.next()
                        this.isClicked = false;
                        $('#textBtnubahemail').show();
                        $('#btnubahemail').prop('disabled', false);
                    }else {
	                    $('#loadingPage').removeClass('overlayLoading');
	                    this.isClickedloader = false;
	                    
	                    this.$toast.error(res.data.msg)
	
	                    this.isClicked = false;
	                    $('#textBtnubahemail').show();
	                    $('#btnubahemail').prop('disabled', false);
                    }
                } catch (e) {
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
	
	                this.$catch_error_response(e)
	
	                this.isClicked = false;
	                $('#textBtnubahemail').show();
	                $('#btnubahemail').prop('disabled', false);
                }
            },

            async verifikasipass(){
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').hide();
                this.isClickedloader = true;
                try {
                    const verifikasi = new FormData;
                    verifikasi.append('password', this.password1);
                    const res = await this.$axios.post(this.$baseurl + '/masterData/owner/verifikasi_password_owner_sekarang', verifikasi,this.requestHeaders)
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false;
                        this.password1 ='';
                        this.ubahemail()
                    }else{
	                    $('#loadingPage').removeClass('overlayLoading');
	                    this.isClickedloader = false;
                        this.password1 ='';
                        
                        this.$toast.error(res.data.msg)
                    }
                }catch (e) {
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false;
                	
	                this.$catch_error_response(e)
                }
            },

            async getpasswordowner() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    const res = await this.$axios.get(this.$baseurl + '/masterData/owner/cek_password_owner',  this.requestHeaders);
                    this.status_password = res.data.data
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        this.isClickedloader = false;
                        // $('#loadingPage').hide();
                        var dataownerpass = res.data.data
                        this.status_password = dataownerpass.status_pass_owner;
                    }else{
						this.$toast.error(res.data.data)
                    }
                } catch (e) {
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
	                
	                this.$catch_error_response(e)
	
	                this.isClicked = false
	                $('#textBtnpersonal').show()
	                $('#btnpersonal').prop('disabled', false);
                }
            },
        },
    }
</script>

<style scoped>

</style>